export default __webpack_public_path__ + "static/reed-2--mobile-00206290385c472a877b47b46ef833c6.png";